<div class= "Container">
    <div class= "Container-title">
        <h1>Deseja remover este item do carrinho?</h1>
    </div>
    <div class = "Container-button">
        <button [mat-dialog-close]="true">Sim</button>
        <button [mat-dialog-close]="false">Não</button>
    </div>
</div>
